import styled from '@emotion/styled';

import NextIcon from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { disclosure, hoverOpacity } from '@/utility/theme/animation';

// NOTE: 買い目バッジを考慮して左右paddingは子要素に設定する
export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#fff',
    padding: [
      `${defaultTheme.spacing.s} 0 ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.s} 0 ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.l} 0`,
    ],
    marginTop: defaultTheme.spacing.xs,
  }),
);

export const Content = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `0 ${defaultTheme.spacing.l}`,
  }),
);

export const RaceInfoWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row'],
    alignItems: ['', '', 'center', 'center'],
  }),
);

export const ToggleIcon = styled.i((props: { isOpen: boolean }) =>
  mq({
    display: 'inline-block',
    width: '12px',
    height: '20px',
    border: 'none',
    backgroundImage: `url(${NextIcon})`,
    backgroundSize: '12px 20px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    transform: `rotate(${props.isOpen ? '-90deg' : '90deg'})`,
    transition: '.2s all ease-in-out',
    padding: defaultTheme.spacing.s,
  }),
);

export const LinkArea = styled.div(
  (props: { count: number; isOpen: boolean }) =>
    mq({
      display: 'grid',
      gridTemplateColumns: [
        'repeat(6, 1fr)',
        'repeat(6, 1fr)',
        'repeat(6, 1fr)',
        `repeat(${props.count}, 45px)`,
      ],
      gridAutoRows: '35px',
      gridGap: '8px 4px',
      padding: props.isOpen
        ? `14px ${defaultTheme.spacing.l} 0`
        : `0 ${defaultTheme.spacing.l}`,
      ...disclosure(props.isOpen, '100px'),
      '& > a': {
        ...hoverOpacity,
      },
    }),
);
